import React from 'react';
import { Typography, Button, Alert, CircularProgress, Scrollbar } from '@ann/web-components';
import {
  ToolsPageContainer,
  ToolsPageHeader,
  ToolsPageContent,
  LoadingContainer,
} from './ToolsPage.styled';
import { SelectedTools, SlideoutTools, ToolConfigurationSlideout } from './components';
import { useToolsPage } from './hooks';

const ToolsPage = () => {
  const {
    installedTools,
    availableTools,
    loading,
    loadingToolsList,
    isUpdating,
    showSlideoutTools,
    showConfigurationSlideout,
    selectedToolForConfiguration,
    isFromToolsLibrary,
    showAlert,
    alertMessage,
    alertType,
    handleToggleTool,
    handleDeleteTool,
    handleAddTools,
    handleOpenSlideoutTools,
    handleCloseSlideoutTools,
    handleOpenConfiguration,
    handleCloseConfiguration,
    handleGoBackToToolsLibrary,
    handleSaveConfiguration,
    handleCloseAlert,
  } = useToolsPage();

  if (loading && installedTools.length === 0) {
    return (
      <LoadingContainer>
        <CircularProgress size="xl" />
      </LoadingContainer>
    );
  }

  return (
    <>
      <Scrollbar size="small">
        <ToolsPageContainer>
          <ToolsPageContent>
            <ToolsPageHeader>
              <div>
                <Typography category="subtitle" size="medium" weight="bold">
                  Tool Library
                </Typography>
                <Typography category="body" size="medium" weight="regular" color="body">
                  Give the agent extra abilities to act, respond, or automate.
                </Typography>
              </div>
              <Button
                iconLeft="plus"
                label="Add"
                size="medium"
                type="secondary"
                onClick={handleOpenSlideoutTools}
                disabled={isUpdating}
              />
            </ToolsPageHeader>

            <SelectedTools
              installedTools={installedTools}
              onToggleTool={handleToggleTool}
              onSettings={handleOpenConfiguration}
              onDelete={handleDeleteTool}
            />
          </ToolsPageContent>
        </ToolsPageContainer>
      </Scrollbar>

      <SlideoutTools
        open={showSlideoutTools}
        onClose={handleCloseSlideoutTools}
        onAddTools={handleAddTools}
        onToolConfiguration={handleOpenConfiguration}
        installedTools={installedTools}
        availableTools={availableTools}
        isLoading={loadingToolsList}
      />

      <ToolConfigurationSlideout
        open={showConfigurationSlideout}
        onClose={handleCloseConfiguration}
        tool={selectedToolForConfiguration}
        onSave={handleSaveConfiguration}
        showBackButton={isFromToolsLibrary}
        onBack={handleGoBackToToolsLibrary}
      />

      {showAlert && (
        <Alert
          severity={alertType}
          title={alertMessage}
          onClose={handleCloseAlert}
          maxWidth="500px"
          closable={true}
          autoClose={true}
          autoCloseDelay={5000}
        />
      )}
    </>
  );
};

export default ToolsPage;

